export default __webpack_public_path__ + "static/media/DAZAPP-Logo.1e0e05f2.svg";